import { interceptor } from "./interceptor";
import axios from "axios";
import config from "../config";

export const ax = axios.create({
    baseURL: config.backendUrl,
});

interceptor(ax);